module.exports = __webpack_public_path__ + "img/公众号二维码.caff31d7.jpg";